import vista from "@/assets/vista.webp";

export function Vista() {
  return (
    <section aria-label="A quiet moment" className="relative py-16 sm:py-24">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <div className="reveal relative overflow-hidden rounded-3xl shadow-[var(--shadow-lift)]">
          <img
            src={vista}
            alt="Sunrise breaking over misty Minnesota hills — a quiet vista evoking calm and perspective"
            width={800}
            height={300}
            sizes="(min-width: 1280px) 80rem, 100vw"
            loading="lazy"
            decoding="async"
            className="aspect-[8/3] h-auto w-full scale-110 object-cover transition-transform duration-[1400ms] ease-out hover:scale-100"
          />
          <div
            aria-hidden
            className="absolute inset-0"
            style={{
              background:
                "linear-gradient(90deg, oklch(0.24 0.02 145 / 0.78) 0%, oklch(0.24 0.02 145 / 0.45) 45%, oklch(0.24 0.02 145 / 0.15) 100%)",
            }}
          />
          <div className="absolute inset-0 flex items-center">
            <div className="max-w-xl px-8 sm:px-14 text-cream">
              <p className="text-xs font-medium uppercase tracking-[0.24em] text-cream/80">
                Mediator · Counsel
              </p>
              <h2 className="mt-4 font-display text-4xl font-medium leading-[1.05] tracking-tight text-balance sm:text-5xl">
                Sometimes you just need somewhere quiet to set things down.
              </h2>
              <p className="mt-5 text-base leading-relaxed text-cream/85">
                Whether you're navigating a hard season or a hard decision — there's room here to
                think it through, out loud, with someone who's heard a lot of it before.
              </p>
              <a
                href="#contact"
                className="mt-7 inline-flex items-center gap-2 rounded-full bg-cream px-6 py-3 text-sm font-medium text-ink shadow-[var(--shadow-soft)] transition-transform hover:-translate-y-0.5"
              >
                Reach out
                <span aria-hidden>→</span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
